/**
 * Created by Jie Gao on 2021-02-22.
 */
import {IScreenViewConfig, ScreenView} from "@nolimitcity/slot-game/bin/core/screen/ScreenView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {GGParsedGameData} from "../../server/data/GGParsedGameData";
import {TweenLite, TimelineLite, Linear} from "gsap";
import {FontStyleConfig} from "../../config/FontStyleConfig";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {GGGameModuleConfig} from "../../GGGameModuleConfig";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {GGParsedInitData} from "../../server/data/GGParsedInitData";
import {cloneScreenBounds, ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";

export class GGFreeSpinIntroView extends ScreenView {

    private _container:PIXI.Container;
    private _fsNumber:PIXI.BitmapText;
    private _xBomGuaranteed:PIXI.Text;
    private _featureSplash:PIXI.Sprite;
    private _featureAnimation:PIXI.spine.Spine;
    private _dimmer:PIXI.Sprite;
    private _roundType: number;

    constructor(config:IScreenViewConfig, autoClose?:boolean) {
        super(config, false);
        this._container = new PIXI.Container();

        this._roundType = -1;
    }

    protected createGameGraphics():PIXI.DisplayObject {
        this._container = new PIXI.Container();
        this._dimmer = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._dimmer.anchor.set(0.5, 0.5);
        this._dimmer.position.set(0, 0);
        this._dimmer.tint = 0X000000;
        this._dimmer.alpha = 0.5;
        this._container.addChild(this._dimmer);
        this._featureSplash = new PIXI.Sprite();
        this._featureSplash.position.set(0, -35);
        this._container.addChild(this._featureSplash);
        this._fsNumber = new PIXI.BitmapText("0", FontStyleConfig.FSNUMBEROnFSIntro);
        this._fsNumber.position.set(0, 142);
        this._featureSplash.addChild(this._fsNumber);
        this._xBomGuaranteed = new PIXI.Text(Translation.translate("Guaranteed xBomb"), {
            fill : 0xFFFF00,
            fontFamily : "Open Sans",
            wordWrap : true,
            wordWrapWidth : 680,
            fontSize : 40
        });
        this._xBomGuaranteed.visible = false;
        this._xBomGuaranteed.position.set(0-this._xBomGuaranteed.width*0.5, 280);
        this._featureSplash.addChild(this._xBomGuaranteed);
        this.addChild(this._container);
        return this._container;
    }

    protected setButtonPosition():void {
        this._button.position.x = 360;
        if (NolimitApplication.isLandscape) {
            this._button.position.y = 615;
        }
        else {
            const bounds: ScreenBounds = cloneScreenBounds(NolimitApplication.screenBounds);
            this._button.position.y = (bounds.bottom - 610) * 0.5 + 610;
        }
    }

    public enableButton() {
        this._button.visible = true;
        this._button.enabled = true;
    }

    protected onButtonClick(): void{
        super.onButtonClick();
        this._button.enabled = false;
        GGGameModuleConfig.soundPlayer.playFsButtonClickSound();
    }

    public show(data?:GGParsedGameData, onShowComplete?:() => void):void {
        this._button.visible = false;
        this._button.enabled = false;
        this._fsNumber.text = data!.freespinsLeft.toString();
        this._fsNumber.position.x = -6-this._fsNumber.width*0.5;
        this._fsNumber.visible = false;
        this._xBomGuaranteed.visible = false;
        this.alpha = 0;
        super.show(data, onShowComplete);
    }

    protected startPresentation(data:GGParsedGameData, onShowComplete?:() => void):void {
        const tl:TimelineLite = new TimelineLite({
            onComplete:onShowComplete
        });

        let nrScatters:number = data.numScattersEnterFS>8?4:3;
        let startTime:number = 0.1;
        const isRestore:boolean = (data instanceof GGParsedInitData) ? (<GGParsedInitData>data).isRestoreState : false;

        if(isRestore){
            this._roundType = (data.roundType === 2 ||(data.nextMode === "SUPER_FREESPIN"))?2:1;
        }else{
            this._roundType = (data.nextMode === "FREESPIN")?1:2;
        }

        const fsType:string = this._roundType<2?"normal":"super";
        const featureSplashTextureName:string = (`fsIntro_${fsType}_${nrScatters}s${data.bombGuarantee?"_bomb":""}`);
        this._featureAnimation = new PIXI.spine.Spine(GameResources.getSpineAsset(featureSplashTextureName));
        this._featureAnimation.renderable = false;
        this._featureAnimation.pivot.set(0.5, 0.5);
        this._featureAnimation.name = featureSplashTextureName;
        this._featureAnimation.position.set(0, 0);
        this._featureSplash.addChild(this._featureAnimation);
        this._featureSplash.addChild(this._fsNumber);
        this._featureSplash.addChild(this._xBomGuaranteed);

        tl.add([
            new TweenLite(this, 0.3, {alpha : 1, ease : Linear.easeNone})
        ],0.1);
        tl.add(() => {
            this._featureAnimation.renderable = true;
            this._featureAnimation.state.setAnimation(0,"FMS_Intro",false);
            GGGameModuleConfig.soundPlayer.playFSIntroSound(fsType, data.bombGuarantee);
            // #403
            TweenLite.to(StageManager.stage, 0.2, {
                x: "+=" + 10,
                y: "+=" + 10,
                ease: "shakeBounce"
            });
        },startTime+0.4);
        tl.add([
            GGGameModuleConfig.fsCounter.showFlag((`fsBadge_${fsType}${data.bombGuarantee ? "_bomb" : ""}`), data!.freespinsLeft, false),
            () => {
                if(data.bombGuarantee){
                    this._xBomGuaranteed.visible = true;
                }
                this._fsNumber.visible = true;
                this._featureAnimation.state.setAnimation(0,"FMS_Idle",true);
            },
        ], startTime+1.9);
    }

    protected stopPresentation(closeCallback?:() => void):void {
        const tl:TimelineLite = new TimelineLite();

        // #403
        GGGameModuleConfig.soundPlayer.playFSAmbianceSound(this._roundType);

        this._fsNumber.visible = false;
        this._xBomGuaranteed.visible = false;
        this._featureAnimation.renderable = false;
        this._featureAnimation.visible = false;
        this._featureAnimation.state.setEmptyAnimation(0, 0);
        tl.add(new TweenLite(this, 0.25, {alpha : 0, ease : Linear.easeNone}), 0);
        tl.add(() => super.stopPresentation(closeCallback));
    }

    protected onResizeGameGraphics(resizeData:IResizeData):void {
        const splashScale:number = resizeData.orientation === Orientation.PORTRAIT?0.9:0.7;
        this._container.position.set(360, 360);
        this._featureSplash.scale.set(splashScale, splashScale);
        this._dimmer.width = resizeData.width + 100;
        this._dimmer.height = resizeData.height + 100;
    }
}